import './App.scss';
import './styles/CalendarStyles.css';
import './styles/global.scss';
import { BrowserRouter, Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

import NotificationSettings from './components/NotificationSettings/NotificationSettings';
import PrivacySettings from './components/PrivacySettings/PrivacySettings';
import TermsAndConditions from './components/TermsAndConditions/TermsAndConditions';
import Analytics from './pages/Analytics/Analytics';
import AnalyticsDetail from './pages/Analytics/AnalyticsDetail';
import ActionsToday from './pages/Analytics/ActionsToday';
import EventsDetail from './pages/Analytics/EventsDetail';
import VenueActivity from './pages/Analytics/VenueActivity';
import OnboardingFunnel from './pages/OnboardingFunnel/OnboardingFunnel';
import OnboardingFunnelLog from './pages/OnboardingFunnel/OnboardingFunnelLog';
import EngineStats from './pages/EngineStats/EngineStats';
import TablesTonight from './pages/TablesTonight/TablesTonight';
import AiAnalyst from './pages/AiAnalyst/AiAnalyst';
import VipMemberships from './pages/VipMemberships/VipMemberships';
import AddAd from './pages/AddAd/AddAd';
import AddEvent from './pages/AddEvent/AddEvent';
import AddUsers from './pages/AddUsers/AddUsers';
import AddVenue from './pages/AddVenue/AddVenue';
import AdManagement from './pages/AdManagement/AdManagement';
import AdEngagedUsers from './pages/AdEngagedUsers/AdEngagedUsers';
import EditAd from './pages/EditAd/EditAd';
import EditEvent from './pages/EditEvent/EditEvent';
import EditUsers from './pages/EditUsers/EditUsers';
import EditVenue from './pages/EditVenue/EditVenue';
import Events from './pages/Events/Events';
import LiquorSponsor from './pages/LiquorSponsor/LiquorSponsor';
import Moderators from './pages/Moderators/Moderators';
import Verifications from './pages/Verifications/Verifications';
import UserActivity from './pages/UserActivity/UserActivity';
import Elite from './pages/Elite/Elite';
import Boost from './pages/Boost/Boost';
import PhotoReview from './pages/PhotoReview/PhotoReview';
import TableModeration from './pages/TableModeration/TableModeration';
import MyOrganizer from './pages/MyOrganizer/MyOrganizer';
import Organizers from './pages/Organizers/Organizers';
import PromoterDemos from './pages/PromoterDemos/PromoterDemos';
import Promotion from './pages/Promotion/Promotion';
import Queries from './pages/Queries/Queries';
import Settings from './pages/Settings/Settings';
import SmsAccessSettings from './components/SmsAccessSettings/SmsAccessSettings';
import SignIn from './pages/SignIn/SignIn';
import Sponsorship from './pages/Sponsorship/Sponsorship';
import UserProfile from './pages/UserProfile/UserProfile';
import Users from './pages/Users/Users';
import DeletedUsers from './pages/DeletedUsers/DeletedUsers';
import DeletedUserDetail from './pages/DeletedUsers/DeletedUserDetail';
import VoiceCalls from './pages/VoiceCalls/VoiceCalls';
import VoiceCallDetail from './pages/VoiceCalls/VoiceCallDetail';
import InboundTexts from './pages/InboundTexts/InboundTexts';
import AssistantConversations from './pages/AssistantConversations/AssistantConversations';
import ReviewPrompts from './pages/ReviewPrompts/ReviewPrompts';
import AnonymousUsers from './pages/AnonymousUsers/AnonymousUsers';
import WebGuests from './pages/WebGuests/WebGuests';
import PaymentsToFinish from './pages/PaymentsToFinish/PaymentsToFinish';
import DiscoverInvites from './pages/DiscoverInvites/DiscoverInvites';
import ProfileViews from './pages/ProfileViews/ProfileViews';
import OrganizerRequestDetails from './pages/OrganizerRequestDetails/OrganizerRequestDetails'
import DjRequests from './pages/DjRequests/DjRequests'
import JoinRequests from './pages/JoinRequests/JoinRequests'
import PromoterRequests from './pages/PromoterRequests/PromoterRequests'
import AffiliateWaitlist from './pages/AffiliateWaitlist/AffiliateWaitlist';
import Affiliates from './pages/Affiliates/Affiliates';
import AffiliatePayouts from './pages/AffiliatePayouts/AffiliatePayouts';
import AffiliateAnalytics from './pages/AffiliateAnalytics/AffiliateAnalytics';
import AffiliateDemos from './pages/AffiliateDemos/AffiliateDemos';
import Venues from './pages/Venues/Venues';
import Brands from './pages/Brands/Brands';
import VenueSync from './pages/VenueSync/VenueSync';
import SpotlightEvent from './pages/SpotlightEvent/SpotlightEvent'

import PromotersList from './pages/Promoters/List/PromotersList';
import PromotersNew from './pages/Promoters/New/PromotersNew';
import PromotersEdit from './pages/Promoters/Edit/PromotersEdit';
import EditQueries from './pages/EditQueries/EditQueries';


import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from './services/api';
import TwoFactorAuth from './pages/TwoFactorAuth';
import AcceptVenueRequest from './pages/VenueRequest';
import NewBarCrawlEvent from './pages/Events/NewBarCrawlEvent/New';
import EditBarCrawlEvent from './pages/Events/NewBarCrawlEvent/Edit';
import ReviewGuestList from './pages/Events/ReviewGuestList';
import ReviewTicketList from './pages/Events/ReviewTicketList';
import EditTicketSales from "./components/TicketSales/Edit";
import MembershipRequestDetails from './pages/MembershipRequestDetails/MembershipRequestDetails';
import OrganizerVenuesRequestDetails from './pages/OrganizerVenuesRequestDetails/OrganizerVenuesRequestDetails';
import AddChat from "./pages/Chat/AddChat/AddChat";
import EditChat from "./pages/Chat/EditChat/EditChat";
import ChatList from "./pages/Chat/ChatList/ChatList";
import UserInboxes from "./pages/Chat/UserInboxes/UserInboxes";
import SharedDevices from "./pages/SharedDevices/SharedDevices";
import Drinks from "./pages/Drinks/Drinks";
import PlanThemes from "./pages/PlanThemes/PlanThemes";
import FlaggedNames from "./pages/FlaggedNames/FlaggedNames";
import EventFeedback from "./pages/EventFeedback/EventFeedback";
import {FormDataProvider} from "./FormDataContext";
import SelectParticipants from "./pages/Chat/AddChat/SelectParticipants";
import ParticipantDetails from "./pages/Chat/EditChat/ParticipantDetails/ParticipantDetails";
import WithdrawalRequests from "./components/WithdrawalRequests/List/WithdrawalRequests";
import WithdrawalRequestDetails from "./components/WithdrawalRequests/Details/WihdrawalRequestDetails";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import LegalEditorPage from "./pages/LegalEditorPage/LegalEditorPage";
import Legal from "./pages/Legal/Legal";
import ListOffers from "./components/Offers/List";
import NewOffer from "./components/Offers/New";
import EditOffer from "./components/Offers/Edit";
import ListRedeems from "./components/Offers/RedeemedList";
import ListRefundRequests from "./pages/Refund";
import ListCancellationRequests from "./pages/CancellationRequests";
import AppVersions from "./pages/AppVersions/AppVersions";
import {AuthProvider, useAuth} from "./AuthContext";
import Followers from "./pages/Venues/followers/Followers";
import { BadgeCountsProvider } from "./contexts/BadgeCountsContext";
import PushNotifications from "./pages/PushNotifications/PushNotifications";
import PushNotificationDetail from "./pages/PushNotifications/PushNotificationDetail";
import ManualPushes from "./pages/ManualPushes/ManualPushes";
import Plans from "./pages/Plans/Plans";
import PushSchedule from "./pages/PushSchedule/PushSchedule";
import VenueBroadcasts from "./pages/VenueBroadcasts/VenueBroadcasts";
import ReviewBottleService from "./pages/Events/ReviewBottleService";
import BrandBook from "./pages/BrandBook/BrandBook";
import InvestorDashboard from "./pages/InvestorDashboard/InvestorDashboard";
import PushOpens from "./pages/PushOpens/PushOpens";

function ProtectedRoutes() {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return null;
    }
    return user ? (
        <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
        >
            <Outlet />
        </motion.div>
    ) : <Navigate to="/signin" replace />;
}

function AppRoutes() {
    return (

            <Routes>
                <Route path="/signin" element={<SignIn />} />

                <Route path="/two-factor-auth" element={<TwoFactorAuth />} />

                <Route element={<ProtectedRoutes />}>

                            {/* <Route path="/" element={<Moderators />} /> */}
                            {/* AI Analyst is the landing surface: the first
                                question on opening the panel is almost always
                                "what happened / what did X do", and that is
                                what it answers. /users still has its own route
                                below, so nothing moved. */}
                            <Route path="/" element={<AiAnalyst />} />
                            <Route path="/analytics" element={<Analytics />} />
                            <Route path="/analytics/detail" element={<AnalyticsDetail />} />
                            <Route path="/analytics/actions-today" element={<ActionsToday />} />
                            <Route path="/analytics/events" element={<EventsDetail />} />
                            <Route path="/onboarding-funnel" element={<OnboardingFunnel />} />
                            <Route path="/onboarding-funnel/log" element={<OnboardingFunnelLog />} />
                            <Route path="/venue-activity" element={<VenueActivity />} />
                            <Route path="/engine-stats" element={<EngineStats />} />
                            <Route path="/tables-tonight" element={<TablesTonight />} />
                            <Route path="/ai-analyst" element={<AiAnalyst />} />
                            <Route path="/moderators" element={<Moderators />} />
                            <Route path="/verifications" element={<Verifications />} />
                            <Route path="/user-activity" element={<UserActivity />} />
                            <Route path="/elite" element={<Elite />} />
                            <Route path="/boost" element={<Boost />} />
                            <Route path="/photo-review" element={<PhotoReview />} />
                            <Route path="/table-moderation" element={<TableModeration />} />
                            <Route path="/my-organizer" element={<MyOrganizer />} />
                            <Route path="/organizers" element={<Organizers />} />
                            <Route path="/dj-requests" element={<DjRequests />} />
                            <Route path="/join-requests" element={<JoinRequests />} />
                            <Route path="/promoter-requests" element={<PromoterRequests />} />
                            <Route path="/affiliate-waitlist" element={<AffiliateWaitlist />} />
                            <Route path="/affiliates" element={<Affiliates />} />
                            <Route path="/affiliate-payouts" element={<AffiliatePayouts />} />
                            <Route path="/affiliate-analytics" element={<AffiliateAnalytics />} />
                            <Route path="/affiliate-demos" element={<AffiliateDemos />} />
                            <Route path="/vip-memberships" element={<VipMemberships />} />
                            {/* <Route path="/organizer-requests" element={<OrganizerRequests />} /> */}
                            <Route path="/organizer-requests/:userID" element={<OrganizerRequestDetails />} />
                            {/* <Route path="/organizer-requests" element={<OrganizerRequests />} /> */}
                            <Route path="/organizer-venue-requests/:userID" element={<OrganizerVenuesRequestDetails />} />
                            <Route path="/membership-requests/:userID" element={<MembershipRequestDetails />} />
                            <Route path="/users" element={<Users />} />
                            <Route path="/deleted-users" element={<DeletedUsers />} />
                            <Route path="/deleted-users/:userId" element={<DeletedUserDetail />} />
                            <Route path="/voice-calls" element={<VoiceCalls />} />
                            <Route path="/voice-calls/:callId" element={<VoiceCallDetail />} />
                            <Route path="/inbound-texts" element={<InboundTexts />} />
                            <Route path="/866-conversations" element={<AssistantConversations />} />
                            <Route path="/anonymous-users" element={<AnonymousUsers />} />
                            <Route path="/web-guests" element={<WebGuests />} />
                            <Route path="/payments-to-finish" element={<PaymentsToFinish />} />
                            <Route path="/review-prompts" element={<ReviewPrompts />} />
                            <Route path="/discover-invites" element={<DiscoverInvites />} />
                            <Route path="/profile-views" element={<ProfileViews />} />
                            <Route path="/users/add" element={<AddUsers />} />
                            <Route path="/users/edit/:userID" element={<EditUsers />} />
                            <Route path="/users/:userID" element={<UserProfile />} />
                            <Route path="/business" element={<Venues market="miami" />} />
                            <Route path="/nyc-venues" element={<Venues market="nyc" />} />
                            <Route path="/venue-sync" element={<VenueSync />} />
                            <Route path= "/withdrawal-requests" element={<WithdrawalRequests />} />
                            <Route path="/business/add" element={<AddVenue />} />
                            <Route path="/withdrawal-request-details/:requestId" element={<WithdrawalRequestDetails/>}/>
                            <Route
                                path="/business/edit/:venueId"
                                element={<EditVenue />}
                            />
                            <Route path="/spotlight/event/:eventId" element={<SpotlightEvent />} />
                            <Route path="/events" element={<Events />} />
                            <Route path='/events/add' element={<AddEvent />} />
                            <Route path='/events/edit/:eventID' element={<EditEvent />} />

                            <Route
                                path="/events/review-guestlist/:eventsId"
                                element={<ReviewGuestList />}
                            />
                            <Route
                                path="/events/review-tickets/:eventsId"
                                element={<ReviewTicketList />}
                            />
                            <Route
                                path="/events/review-bottle-service/:eventsId"
                                element={<ReviewBottleService />}
                            />

                            <Route path="/queries" element={<Queries />} />
                            <Route path="/promoters/list" element={<PromotersList />} />
                            <Route path="/promoters/new" element={<PromotersNew />} />
                            <Route path="/promoters/edit/:promoterId" element={<PromotersEdit />} />
                            <Route path="/promoter-demos" element={<PromoterDemos />} />
                            <Route path="/spotlight" element={<Sponsorship />} />
                            <Route path='/liquor' element={<LiquorSponsor />} />
                            <Route path='/ad-management' element={<AdManagement />} />
                            <Route path='/ad-management/edit/:adID' element={<EditAd />} />
                            <Route path='/ad-management/add' element={<AddAd />} />
                            <Route path='/ad-management/engaged' element={<AdEngagedUsers />} />
                            <Route path="/promotion" element={<Promotion />} />
                            <Route path="/queries/list" element={< Queries />} />
                            <Route path="/queries/edit/:queriesId" element={< EditQueries />} />
                            <Route path="/venue-requests/view/:venueRequestId" element={<AcceptVenueRequest />} />

                            <Route path="/bar-crawl-event/new" element={<NewBarCrawlEvent />} />
                            <Route path="/push-notifications" element={<PushNotifications />} />
                            <Route path="/push-notifications/:groupKey" element={<PushNotificationDetail />} />
                            <Route path="/manual-pushes" element={<ManualPushes />} />
                            <Route path="/plans" element={<Plans />} />
                            <Route path="/push-schedule" element={<PushSchedule />} />
                            <Route path="/venue-broadcasts" element={<VenueBroadcasts />} />
                            <Route path="/push-opens" element={<PushOpens />} />
                            <Route path="/refund-requests" element={<ListRefundRequests />} />
                            <Route path="/cancellation-requests" element={<ListCancellationRequests />} />
                            <Route path="/app-versions" element={<AppVersions />} />
                            <Route path="/bar-crawl-event/edit/:eventId" element={<EditBarCrawlEvent />} />
                            <Route path="/ticket-sales/edit/:ticketId" element={<EditTicketSales />} />

                            <Route path="/create-chat" element={<AddChat/>} />
                            <Route path="/chats" element={<ChatList/>} />
                            <Route path="/user-inboxes" element={<UserInboxes/>} />
                            <Route path="/shared-devices" element={<SharedDevices/>} />
                            <Route path="/drinks" element={<Drinks/>} />
                            <Route path="/plan-themes" element={<PlanThemes/>} />
                            <Route path="/flagged-names" element={<FlaggedNames/>} />
                            <Route path="/event-feedback" element={<EventFeedback/>} />
                            <Route path="/edit-chat/:id" element={<EditChat/>} />
                            <Route path="/add-participants" element={<SelectParticipants/>} />
                            <Route path="/venue/followers/:venueId" element={<Followers/>} />

                            <Route path="/brand-book" element={<BrandBook />} />
                            <Route path="/investor" element={<InvestorDashboard />} />
                            <Route path="/brands" element={<Brands />} />

                            <Route path="/settings" element={<Settings />}>
                                <Route index element={<Navigate to="privacy" replace />} />
                                <Route path="privacy" element={<PrivacySettings />} />
                                <Route
                                    path="notifications"
                                    element={<NotificationSettings />}
                                />
                                <Route
                                    path="terms-and-conditions"
                                    element={<TermsAndConditions />}
                                />
                                <Route
                                    path="privacy-policy"
                                    element={<PrivacyPolicy />}
                                />
                                <Route path="sms-access" element={<SmsAccessSettings />} />
                            </Route>

                            <Route path="/legal" element={<Legal />} />
                            <Route path="/legal/:type/:document" element={<LegalEditorPage />} />

                            <Route path="/offers" element={<ListOffers />} />
                            <Route path="/offers/new" element={<NewOffer />} />
                            <Route path="/offers/:offerId/edit" element={<EditOffer />} />
                            <Route path="/offers/:offerId/redeemed" element={<ListRedeems />} />
                        </Route>

                        <Route path="*" element={<Navigate to="/signin" />} />


            </Routes>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <ToastContainer />
            <AuthProvider>
                <BadgeCountsProvider>
                    <FormDataProvider>
                        <AppRoutes />
                    </FormDataProvider>
                </BadgeCountsProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

